interface SelectProps {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  options: Array<{ value: string; label: string }>;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  id?: string;
}

export default function Select({
  label,
  value,
  onChange,
  options,
  placeholder,
  error,
  disabled,
  required,
  id,
}: SelectProps) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className="block text-[13px] font-medium text-ink-mid mb-1.5"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          required={required}
          className={[
            'w-full py-3 pl-3.5 pr-8 text-[15px] text-ink-dark bg-white',
            'border rounded-sm outline-none appearance-none',
            'transition-[border-color,box-shadow] duration-150',
            error
              ? 'border-accent-danger shadow-[0_0_0_3px_rgba(220,38,38,0.10)]'
              : 'border-stone-border focus:border-sage focus:shadow-[0_0_0_3px_rgba(107,128,104,0.13)]',
            disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {/* Chevron icon */}
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-ink-soft">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 5l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>
      {error && (
        <p className="mt-1 text-[12px] text-accent-danger">{error}</p>
      )}
    </div>
  );
}
